<template>
    <div v-if="visible" class="connection-overlay position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center">
        <div v-if="$store.state.network != 'session_conflict'" class="spinner-border text-light mb-3" role="status"></div>
        <div class="connection-overlay-message">{{ message }}</div>
    </div>
</template>

<script>
import utils from '@/../../shared/utils'

// Event mode's whole flow (Panel, Auth, Activity, everything) is driven
// live over this websocket, so losing it means the app is genuinely stuck
// until it reconnects - worth a blocking, explicit message instead of a
// silently frozen screen. Online mode's player-facing flows never depend on
// this connection at all (see client.js's client_update() gate and
// network.js's REST interception for UPDATE_ACTIVITY), so this stays
// hidden there even if the same background socket drops.
export default {
    name: 'ConnectionOverlay',
    computed: {
        visible(){
            if(window.MODE == utils.APP_MODES.ONLINE)
                return false;
            return this.$store.state.network != 'connected';
        },
        message(){
            switch(this.$store.state.network){
                case 'reconnecting':
                case 'disconnected':
                    return 'Se ha perdido la conexión. Reconectando...';
                case 'error':
                    return 'Error de conexión. Reintentando...';
                // Set by client.js's session_already_active() - a second tab/
                // device joined with this same session, so this one stops
                // trying to reconnect instead of fighting it for the slot.
                case 'session_conflict':
                    return 'Esta sesión ya está activa en otra pestaña o dispositivo. Ciérrala, o cierra esta, y recarga para volver a entrar.';
                default:
                    return 'Conectando con el servidor...';
            }
        }
    }
}
</script>

<style scoped>
    .connection-overlay{
        z-index: 2000;
        background-color: rgba(23, 32, 43, 0.92);
    }

    .connection-overlay-message{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 1.1rem;
        color: var(--vc-paper-50, #fafaf9);
        text-align: center;
        padding: 0 1.5rem;
    }
</style>
